import { useMemo } from 'react';

import { yupResolver } from '@hookform/resolvers/yup';
import type { AlertConfigurationRule } from '@rtkwlf/rendall';
import type { SubmitHandler } from 'react-hook-form';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import * as yup from 'yup';

import { hasIdenticalAlertEntry } from '../../has-identical-alert-entry/has-identical-alert-entry';

import { toFormData, fromFormData } from './transform';

export type DeniedLoginLocation = { 0: string };

export interface FormData {
  country: string;
}

export const useDeniedLoginLocationsForm = ({
  defaultValues,
  onSubmit,
  alert,
}: {
  defaultValues?: DeniedLoginLocation;
  onSubmit: (newValues: string) => void;
  alert?: AlertConfigurationRule;
}) => {
  const { t } = useTranslation('components', {
    keyPrefix: 'alertConfigurationRules',
  });

  const handleSubmitTransformation: SubmitHandler<FormData> = (data) => {
    onSubmit(fromFormData(data));
  };

  const form = useForm<FormData>({
    defaultValues: toFormData(defaultValues),
    resolver: yupResolver(
      yup.object().shape({
        country: yup.string().required(t('singleCountryRequired')),
      }),
    ),
  });

  const formData = form.watch();
  const isDuplicate = useMemo(() => {
    return alert?.data && form.formState.isDirty
      ? hasIdenticalAlertEntry(alert.data, fromFormData(formData))
      : false;
  }, [alert?.data, formData, form.formState.isDirty]);

  return {
    control: form.control,
    handleSubmit: form.handleSubmit(handleSubmitTransformation),
    reset: form.reset,
    formState: form.formState,
    isDuplicate,
  };
};
